import { render, staticRenderFns } from "./SpecialFunctionBaseQuery.vue?vue&type=template&id=724e58f0"
import script from "./SpecialFunctionBaseQuery.vue?vue&type=script&lang=js"
export * from "./SpecialFunctionBaseQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports